export const resolveId = (obj) => {
    if (obj?.id) {
        return obj.id;
    }
    if (obj?._id) {
        console.log('[Wix Blog]', 'No "id" field found', obj);
        return obj._id;
    }
    if (obj?.internalId) {
        return obj.internalId;
    }
    return undefined;
};
/**
 * Kept for backwards compatibility
 *
 * @deprecated
 */
export const resolveLegacyId = (obj) => obj?._id ?? obj?.internalId;
//# sourceMappingURL=resolve-id.js.map